import { getPlaylistAssignmentsUrl, PlaylistAssignmentsBlankPage, PlaylistAssignmentsForPortalList, PlaylistAssignmentsForPortalTable, PlaylistAssignmentsTablePage, usePlaylistAssignmentsForPortal, usePlaylistAssignmentsParams } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { usePortal } from '../../portals';
import { NavMarker } from 'react-rhumb';
import { AssignPlaylistButton } from './AssignPlaylistButton';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaylistAssignmentsForPortalCount = ({
  count
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.playlistAssignments.assignmentsCount`,
    options: {
      count
    }
  });
};
const PlaylistAssignmentsForPortal = ({
  playlistId: propPlaylistId,
  portalId: propPortalId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    portalId: paramPortalId,
    playlistId: paramPlaylistId
  } = usePlaylistAssignmentsParams();
  const portalId = propPortalId || paramPortalId;
  const playlistId = propPlaylistId || paramPlaylistId;
  const {
    portal,
    portalLoading
  } = usePortal({
    portalId,
    skip: !portalId
  });
  const {
    total,
    playlistAssignmentsForPortalLoading
  } = usePlaylistAssignmentsForPortal({
    playlistId,
    portalId
  });
  const isLoading = portalLoading || playlistAssignmentsForPortalLoading;
  if (!portalId || !playlistId || isLoading) return null;
  if (!total) return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYLIST_ASSIGNMENTS_LOADED",
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPage, {
      playlistId: playlistId,
      portalId: portalId
    })
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYLIST_ASSIGNMENTS_LOADED",
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
      actions: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
          playlistId: playlistId,
          portalId: portalId,
          style: {
            overflow: 'visible'
          }
        })
      })
      // do not show back button if not using the routing
      ,
      backButton: paramPortalId ? {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlistAssignments.backLink"
        }),
        to: getPlaylistAssignmentsUrl(playlistId)
      } : undefined,
      enabledFilters: [FILTER_TYPES.SEARCH_USER],
      headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assignmentsForPortalHeader",
        options: {
          portalName: portal && portal.companyName || ''
        }
      }),
      tableCount: /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalCount, {
        count: total
      }),
      children: isMobile ? /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalList, {
        playlistId: playlistId,
        portalId: portalId
      }) : /*#__PURE__*/_jsx(PlaylistAssignmentsForPortalTable, {
        playlistId: playlistId,
        portalId: portalId
      })
    })
  });
};
export default PlaylistAssignmentsForPortal;